import { render, staticRenderFns } from "./VHeadlineAction.vue?vue&type=template&id=3a05ce98"
import script from "./VHeadlineAction.vue?vue&type=script&lang=ts"
export * from "./VHeadlineAction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports